// `sl_customer_account_movement_id, sl_customer_id, number


//
export default [
    {
        name: "number",
        type: "text-field",
        props: {
            label: "Numero",
        },
    },
]